import { Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

export const GroupUserData = (props) => {

    const { title } = props;

    const [isTitle, setIsTitle] = useState(false);
    const onTrigger = (event) => {

        props.parentCallback(event);
    }
    
    useEffect(() => {
        if (title.length > 0) {
            setIsTitle(true);
        }
    }, [ title.length ])
    

    return (
        <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid item xs={12} sx={{ display:(isTitle) ? 'flex' : 'none' }}>
                <h6>{ props.title }</h6>
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    defaultValue={""}
                    fullWidth
                    id={props.userFatherName}
                    label={props.userFatherNameLabel}
                    name={props.userFatherName}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    defaultValue={""}
                    fullWidth
                    id={props.userMotherName}
                    label={props.userMotherNameLabel}
                    name={props.userMotherName}
                    onChange={onTrigger}
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    defaultValue={""}
                    fullWidth
                    id={props.userName}
                    label={props.userNameLabel}
                    name={props.userName}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    defaultValue={""}
                    fullWidth
                    id={props.userEmail}
                    label={props.userEmailLabel}
                    name={props.userEmail}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>
        </Grid>
    );
};
